var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClear(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 10V7.5h1V10h4.5V6.5h-7V10H4zM2 5.5h8V4H7V2H5v2H2v1.5zm-.5 5v-4H1v-3a.5.5 0 01.5-.5H4V1.5a.5.5 0 01.5-.5h3a.5.5 0 01.5.5V3h2.5a.5.5 0 01.5.5v3h-.5v4a.5.5 0 01-.5.5H2a.5.5 0 01-.5-.5z",
    fill: "#58657C"
  })));
}
export default SvgClear;